import { Dataset } from '@api/customTypes';
import { ExternalLinkIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { Box, Stack } from '@mui/material';
import { DatasetDetailsAccordion } from './DatasetDetailsAccordion';
import { useDatasets } from './DatasetsProvider';

export const DatasetDetailsMixParameters = ({
  parameters,
}: {
  parameters: Dataset['source']['parameters'];
}) => {
  const { setSelectedDataset } = useDatasets();
  return (
    <Box sx={{ marginTop: 4 }}>
      <DatasetDetailsAccordion
        title="Mix Parameters"
        details={
          <Stack gap={3} mr={8}>
            {(parameters || [])?.map((data, i) => (
              <Stack key={data?.datasetId} gap={1} ml={4}>
                <Group justifyContent="space-between" alignItems="center">
                  <Group gap={2} alignItems="center">
                    <Typography variant="body2" sx={{ minWidth: '2ch' }}>
                      {i + 1}
                    </Typography>
                    <Typography variant="body2">{data?.dataset}</Typography>
                    <IconButton
                      Icon={ExternalLinkIcon}
                      size={16}
                      onClick={() => setSelectedDataset(data?.datasetId)}
                    />
                  </Group>
                  <Typography variant="body2">{data?.samples}</Typography>
                </Group>
                {data?.classes && (
                  <Typography variant="caption2" sx={{ ml: 'calc( 2ch + 10px )' }}>
                    {data?.classes.join(', ')}
                  </Typography>
                )}
              </Stack>
            ))}
          </Stack>
        }
      />
    </Box>
  );
};
